import { api } from './apiClient';

export interface DeviceStatus {
  id: number;
  sessionId: number;
  status:
    'pending' | 'approved' | 'rejected' | 'revoked' | 'cancelled' | 'ended';
  name: string;
  verificationCode: string;
  createdAt: string;
}

export interface Management {
  sessionId: number;
  enabled: boolean;
  url: string | null;
  devices: DeviceStatus[];
}

export interface SessionParams {
  sessionId: number;
}

export type DeviceAction = 'approve' | 'reject' | 'revoke' | 'restore';

const request = async (
  method: string,
  params: SessionParams & { enabled?: boolean; deviceId?: number },
  signal?: AbortSignal
): Promise<Management> => {
  const result = await api.post<Management>(
    `/session-facilitators/${method}`,
    params,
    { headers: { 'X-Service-Method': method }, signal }
  );
  if (!result || result.sessionId !== params.sessionId) {
    throw new Error('Facilitator management unavailable');
  }
  return result;
};

export const facilitatorsService = {
  getManagement: (params: SessionParams, signal?: AbortSignal) =>
    request('getManagement', params, signal),
  setLinkEnabled: (
    params: SessionParams & { enabled: boolean },
    signal?: AbortSignal
  ) => request('setLinkEnabled', params, signal),
  regenerateLink: (params: SessionParams, signal?: AbortSignal) =>
    request('regenerateLink', params, signal),
  approve: (
    params: SessionParams & { deviceId: number },
    signal?: AbortSignal
  ) => request('approve', params, signal),
  reject: (
    params: SessionParams & { deviceId: number },
    signal?: AbortSignal
  ) => request('reject', params, signal),
  revoke: (
    params: SessionParams & { deviceId: number },
    signal?: AbortSignal
  ) => request('revoke', params, signal),
  restore: (
    params: SessionParams & { deviceId: number },
    signal?: AbortSignal
  ) => request('restore', params, signal),
};
